// テクスチャと FBO の小さなヘルパ。すべてストレートアルファ RGBA8 (または R8)。

export interface Texture {
  tex: WebGLTexture
  width: number
  height: number
  channels: 1 | 4
}

export function createTexture(gl: WebGL2RenderingContext, width: number, height: number, channels: 1 | 4 = 4, data: ArrayBufferView | null = null): Texture {
  const tex = gl.createTexture()
  if (!tex) throw new Error('createTexture に失敗')
  gl.bindTexture(gl.TEXTURE_2D, tex)
  gl.pixelStorei(gl.UNPACK_PREMULTIPLY_ALPHA_WEBGL, false)
  gl.pixelStorei(gl.UNPACK_FLIP_Y_WEBGL, false)
  gl.pixelStorei(gl.UNPACK_ALIGNMENT, 1)
  if (channels === 4) gl.texImage2D(gl.TEXTURE_2D, 0, gl.RGBA8, width, height, 0, gl.RGBA, gl.UNSIGNED_BYTE, data)
  else gl.texImage2D(gl.TEXTURE_2D, 0, gl.R8, width, height, 0, gl.RED, gl.UNSIGNED_BYTE, data)
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, gl.LINEAR)
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, gl.LINEAR)
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_S, gl.CLAMP_TO_EDGE)
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_WRAP_T, gl.CLAMP_TO_EDGE)
  gl.bindTexture(gl.TEXTURE_2D, null)
  return { tex, width, height, channels }
}

export function setTextureFilter(gl: WebGL2RenderingContext, t: Texture, nearest: boolean): void {
  gl.bindTexture(gl.TEXTURE_2D, t.tex)
  const f = nearest ? gl.NEAREST : gl.LINEAR
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MIN_FILTER, f)
  gl.texParameteri(gl.TEXTURE_2D, gl.TEXTURE_MAG_FILTER, f)
  gl.bindTexture(gl.TEXTURE_2D, null)
}

export function deleteTexture(gl: WebGL2RenderingContext, t: Texture | null | undefined): void {
  if (t) gl.deleteTexture(t.tex)
}

export interface Framebuffer {
  fbo: WebGLFramebuffer
  texture: Texture
}

export function createFramebuffer(gl: WebGL2RenderingContext, width: number, height: number): Framebuffer {
  const texture = createTexture(gl, width, height, 4)
  const fbo = gl.createFramebuffer()
  if (!fbo) throw new Error('createFramebuffer に失敗')
  gl.bindFramebuffer(gl.FRAMEBUFFER, fbo)
  gl.framebufferTexture2D(gl.FRAMEBUFFER, gl.COLOR_ATTACHMENT0, gl.TEXTURE_2D, texture.tex, 0)
  const status = gl.checkFramebufferStatus(gl.FRAMEBUFFER)
  gl.bindFramebuffer(gl.FRAMEBUFFER, null)
  if (status !== gl.FRAMEBUFFER_COMPLETE && !gl.isContextLost()) {
    gl.deleteFramebuffer(fbo)
    gl.deleteTexture(texture.tex)
    throw new Error(`FBO が不完全: 0x${status.toString(16)}`)
  }
  return { fbo, texture }
}

export function deleteFramebuffer(gl: WebGL2RenderingContext, f: Framebuffer | null | undefined): void {
  if (!f) return
  gl.deleteFramebuffer(f.fbo)
  gl.deleteTexture(f.texture.tex)
}
